import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { shareReferral } from "../redux/slice/referralSlice";
import { message } from "antd";
 import ListReferralsTableList from "./components/ReferralTable";
import {
  FaFacebookF,
  FaXTwitter,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa6";
import { FiSend } from "react-icons/fi";

import DashboardHeader from "./components/DashboardHeader";
import "./ReferralNew.css";
import User from "./components/User";

// Helper functions to detect the platform
const isAndroid = () => /Android/i.test(navigator.userAgent);
const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);

const Referral = () => {
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const userData = localStorage.getItem("user");
    console.log("userData", userData);
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  const userinfo = user;
  const { sharingReferral } = useSelector((state) => state.refer);
  const referralLink = `${process.env.REACT_APP_CALLBACK_URL}/?referrer=${userinfo?.referralCode}`;
  const mobilreferralLink = `https://play.google.com/store/apps/details?id=com.pollsphere.app&utm_medium=app&referrer=${userinfo?.referralCode}`;
  const iosReferralLink = `https://apps.apple.com/in/app/pollsphere/id6730117064?referrer=${userinfo?.referralCode}`;

  const sendInvite = async (emailToSend) => {
    if (!emailToSend) {
      message.error("Please enter an email address");
      return;
    }
    
    const payload = {
      emails: [emailToSend],
      referralUrl: referralLink
    };
    
    const result = await dispatch(shareReferral(payload));
    if (shareReferral.fulfilled.match(result)) {
      setEmail("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendInvite(email);
  };

  const copyToClipboard = () => {
    let linkToCopy = referralLink;
  
    if (isIOS()) {
      linkToCopy = iosReferralLink;
    } else if (isAndroid()) {
      linkToCopy = mobilreferralLink;
    }
  
    navigator.clipboard.writeText(linkToCopy).then(
      () => {
        message.success("Referral link copied to clipboard!");
      },
      () => {
        message.error("Failed to copy referral link.");
      }
    );
  };

  const shareOnSocialMedia = (platform) => {
    let linkToCopy = referralLink;
  
    if (isIOS()) {
      linkToCopy = iosReferralLink;
    } else if (isAndroid()) {
      linkToCopy = mobilreferralLink;
    }

    const encodedLink = encodeURIComponent(linkToCopy);
    let url = "";

    switch (platform) {
      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}`;
        break;
      case "twitter":
        url = `https://twitter.com/intent/tweet?url=${encodedLink}`;
        break;
      case "linkedin":
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedLink}`;
        break;
      case "whatsapp":
        // Use WhatsApp Web for desktop, WhatsApp app for mobile
        if (isIOS() || isAndroid()) {
          url = `https://wa.me/?text=${encodedLink}`;
        } else {
          url = `https://web.whatsapp.com/send?text=${encodedLink}`;
        }
        break;
      default:
        break;
    }

    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div>
      <DashboardHeader />
      <div className="container dashboard-page mt-4">
        <User />
  <div className="">
        <div className="card p-5 main-referral-card">
        
          <div className="referral-header mb-5">
            <h1 className="h2 fw-bold mb-3">Referrals</h1>
            <p className="text-muted">
              Invite your friends to join our platform. When they sign up and complete surveys, you both earn rewards!
            </p>
          </div>

         
          <div className="referral-steps mb-5">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="step-card text-center">
                  <div className="  mb-3">
                    <div className="step-icon">
                      <img src="./images/ref2.jpg" alt="" />
                    </div>
                    <div className="dashed-line"></div>
                  </div>
                  <h5 className="fw-bold mb-3">Refer With Your Network</h5>
                  <p className="text-muted">
                    Send your referral link to friends and tell them about our amazing rewards!
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="step-card text-center">
                  <div className=" mb-3">
                    <div className="step-icon">
                          <img src="./images/ref1.jpg" alt="" />
                    </div>
                    <div className="dashed-line"></div>
                  </div>
                  <h5 className="fw-bold mb-3">Registration</h5>
                  <p className="text-muted">
                    Let them register to our services using your referral link.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="step-card text-center">
                  <div className=" mb-3">
                    <div className="step-icon">
                          <img src="./images/ref3.jpg" alt="" />
                    </div>
                  </div>
                  <h5 className="fw-bold mb-3">Enjoy Unlimited Earning </h5>
                  <p className="text-muted">
                    Earn rewards for every friend who joins and participates in surveys!
                  </p>
                </div>
              </div>
            </div>
          </div>

      
          <div className="invite-section mb-5 mt-5">
            <h4 className="h5 fw-bold mb-3">Invite your friends</h4>
            <p className="text-muted mb-4">
              Insert your friends' email addresses and send them invitations to join!
            </p>
            <div className="email-input-wrapper">
              <form onSubmit={handleSubmit} className="d-flex align-items-center">
                <input
                  className="form-control email-input"
                  type="email"
                  placeholder="Email addresses..."
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button className="btn-send" type="submit" disabled={sharingReferral}>
                  {sharingReferral ? "..." : <FiSend size={20} />}
                </button>
              </form>
            </div>
          </div>

          {/* Share Referral Link Section */}
          <div className="share-section mt-5">
            <h4 className="h5 fw-bold mb-3">Share the referral link</h4>
            <p className="text-muted mb-4">
              You can also share your referral link by copying and sending it or sharing it on your social media.
            </p>
            <div className="share-link-wrapper d-flex align-items-center gap-3 flex-wrap">
              <div className="link-display flex-grow-1">
                {referralLink}
              </div>
              <button className="btn-copy" onClick={copyToClipboard}>
                Copy link
              </button>
              <div className="social-icons d-flex gap-2">
                <button
                  onClick={() => shareOnSocialMedia("facebook")}
                  className="social-btn facebook-btn"
                  title="Share on Facebook"
                >
                  <FaFacebookF size={18} />
                </button>
                <button
                  onClick={() => shareOnSocialMedia("twitter")}
                  className="social-btn twitter-btn"
                  title="Share on Twitter"
                >
                  <FaXTwitter size={18} />
                </button>
                <button
                  onClick={() => shareOnSocialMedia("linkedin")}
                  className="social-btn linkedin-btn"
                  title="Share on LinkedIn"
                >
                  <FaLinkedinIn size={18} />
                </button>
                <button
                  onClick={() => shareOnSocialMedia("whatsapp")}
                  className="social-btn whatsapp-btn"
                  title="Share on WhatsApp"
                >
                  <FaWhatsapp size={18} />
                </button>
              </div>
            </div>
          </div>
        </div>
        <ListReferralsTableList />
      </div></div>
    </div>
  );
};

export default Referral;
